function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState } from 'react';
import CefMobilePageWrapper from "../../Layout/Wrappers/CefMobilePageWrapper";
import { Keys } from "../../Common/Constants";
import Content from "./Content";
import EducationDataProvider from "../../Providers/Education/EducationDataProvider";
import { FooterButton } from "./FooterButton";
import EducationDataContext from "../../Providers/Education/EducationDataContext";
import { connect } from 'react-redux';
import { getApplication } from "../../../../store/Selectors";
import { setWorkflowData as setWorkflowDataActionCreator, setField as setFieldActionCreator } from "../../../../store/Actions/Actions";
import Question from "../../Common/Question";
import { useCountries } from "../../../../data/countries";
var UnconnectedHighestEducationQuestionContextConsumer = function UnconnectedHighestEducationQuestionContextConsumer(_ref) {
  var onExit = _ref.onExit,
    onSave = _ref.onSave,
    degree = _ref.degree,
    setField = _ref.setField,
    educationCountry = _ref.educationCountry,
    educationLevel = _ref.educationLevel,
    educationStatus = _ref.educationStatus;
  var _useCountries = useCountries(),
    countriesData = _useCountries.countries,
    countriesDataIsLoading = _useCountries.isLoadingCountries;
  var _useContext = useContext(EducationDataContext),
    educationData = _useContext.data,
    educationDataIsLoading = _useContext.isLoading;
  var families = educationData.families,
    levels = educationData.levels;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    educationStatusErrorMessage = _useState2[0],
    setEducationStatusErrorMessage = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    educationCountryErrorMessage = _useState4[0],
    setEducationCountryErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    educationLevelErrorMessage = _useState6[0],
    setEducationLevelErrorMessage = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    degreeErrorMessage = _useState8[0],
    setDegreeErrorMessage = _useState8[1];
  var isLoading = countriesDataIsLoading || educationDataIsLoading;
  return /*#__PURE__*/React.createElement(CefMobilePageWrapper, {
    onExit: onExit,
    onSave: onSave,
    footerButton: isLoading ? null : /*#__PURE__*/React.createElement(FooterButton, {
      countriesData: countriesData,
      degree: degree,
      educationCountry: educationCountry,
      educationLevel: educationLevel,
      educationStatus: educationStatus,
      families: families,
      levels: levels,
      setField: setField,
      setDegreeErrorMessage: setDegreeErrorMessage,
      setEducationCountryErrorMessage: setEducationCountryErrorMessage,
      setEducationLevelErrorMessage: setEducationLevelErrorMessage,
      setEducationStatusErrorMessage: setEducationStatusErrorMessage
    })
  }, /*#__PURE__*/React.createElement(Question, {
    keyName: Keys.Application.educationStatus
  }), /*#__PURE__*/React.createElement(Content, {
    countriesData: countriesData,
    degreeErrorMessage: degreeErrorMessage,
    educationCountryErrorMessage: educationCountryErrorMessage,
    educationData: educationData,
    educationLevelErrorMessage: educationLevelErrorMessage,
    educationStatusErrorMessage: educationStatusErrorMessage,
    isLoading: isLoading,
    setDegreeErrorMessage: setDegreeErrorMessage,
    setEducationCountryErrorMessage: setEducationCountryErrorMessage,
    setEducationLevelErrorMessage: setEducationLevelErrorMessage,
    setEducationStatusErrorMessage: setEducationStatusErrorMessage
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var _ref2;
  var application = getApplication(state);
  return _ref2 = {}, _defineProperty(_ref2, Keys.Application.educationStatus, application.educationStatus), _defineProperty(_ref2, Keys.Application.educationCountry, application.educationCountry), _defineProperty(_ref2, Keys.Application.educationLevel, application.educationLevel), _defineProperty(_ref2, Keys.Application.degree, application.degree), _ref2;
};
var connector = connect(mapStateToProps, {
  setWorkflowData: setWorkflowDataActionCreator,
  setField: setFieldActionCreator
});
var HighestEducationQuestionContextConsumer = connector(UnconnectedHighestEducationQuestionContextConsumer);
var HighestEducationQuestion = function HighestEducationQuestion(_ref3) {
  var onExit = _ref3.onExit,
    onSave = _ref3.onSave;
  return /*#__PURE__*/React.createElement(EducationDataProvider, null, /*#__PURE__*/React.createElement(HighestEducationQuestionContextConsumer, {
    onExit: onExit,
    onSave: onSave
  }));
};
export default HighestEducationQuestion;